import * as Alert from '@active/react-ui/FloatAlert';
import mergeWith from 'lodash/mergeWith';
import noop from 'lodash/noop';
import omit from 'lodash/omit';
import api from './api';
import { interpolate } from '../utils/commonUtils';
import Loading from '../components/Loading';

const { show: defaultShow, hide: defaultHide } = Loading;
const defaultMessageHandler = ({ type, contents }) => Alert[type](contents);

const serviceBuilder = ({
  method = 'post',
  responseType = 'text',
  isSupportLoader = true,
  url: configUrl,
  urlProps,
  params: defaultBody = {},
  headers: defaultHeaders,

  show: buildShow = defaultShow,
  hide: buildHide = defaultHide,

  messageHandler: buildMessageHandler = defaultMessageHandler,
  ...defaultRest
}) => ({
  params: body = {},
  headers,
  accessToken,
  resolve = noop,
  reject = noop,
  complete = noop,

  show = buildShow,
  hide = buildHide,

  messageHandler = buildMessageHandler,
  ...buildRest
} = {}) => {
  const apiCallConfig = {
    ...defaultRest,
    ...buildRest,
    headers: mergeWith({}, defaultHeaders, headers),
    body: mergeWith({}, defaultBody, body),
  };
  // accessToken will be supported from widget props or response datas
  const url = interpolate(configUrl, accessToken ? { accessToken, ...omit(urlProps, [ 'accessToken' ]) } : urlProps);

  isSupportLoader && show();
  return api[method](url, apiCallConfig, responseType)
    .then(
      ({ payload, response }) => resolve.apply(null, [ payload, response ]),
      (error) => {
        messageHandler(error);
        reject(error);
      },
    )
    .finally(() => {
      complete();
      isSupportLoader && hide();
    });
};

export default serviceBuilder;
